export class EventoRaccomandazione {
	event: string;
	entityType: string;
	entityId: string;
	targetEntityType: string;
	targetEntityId: string;
	properties: any;

	user?: UserRaccomandazione;

	constructor(event, entityType, entityId, targetEntityType?, targetEntityId?, properties?) {
		this.event = event;
		this.entityType = entityType;
		this.entityId = entityId;

		if ( targetEntityType ) {
			this.targetEntityType = targetEntityType;

		}
		if ( targetEntityId) {
			this.targetEntityId = targetEntityId;

		}
		if ( properties ) {
			this.properties = properties;
		}
	}
}


/**
 * 
 * 
 * 
	{
		"event":"$set", 
		"entityType": "user",
		"entityId": "google-oauth2-11421563731040427549366",
		"properties":{
			"gender"	:	"M",
			"age"		:	">=35 <45"
		}
	}
 */

export class EventoRaccomandazioneResponse {
	eventId?: string;
	message?: string;
}

export class UserRaccomandazione {
	userId?: string;
	gender?: string;
	age?: string;
}




/*
Esempio per l'aggiunta di una visualizzazione
{
	"event": "view",
	"entityType": "user",
	"entityId": "google-oauth2-114215637310404275493",
	"targetEntityType": "item",
	"targetEntityId": "5f59b893dd1fc50001ee1d71",
		"properties": {
		"platform":"linux",
		"location": "Brindisi"
		}
}

----------------------------------------------------------------

Esempio per l'aggiunta di un rating
{
	"event":"rate",
	"entityType":"user",
	"entityId":"google-oauth2-114215637310404275493",
	"targetEntityType":"item",
	"targetEntityId":"5eeb1c58910488000156b283",
	"properties": {
			"platform":"ios",
			"location":"taranto",
			"rating":4

	}
}
*/